<app-banner></app-banner>
<br>

<div class="contenedorMain">
    <div class="contenedorChild">
        <br>

        <h2 style="text-align: center;">Reporte Detalle por Region</h2>
        <div class="row">
       
            <div class="col-md-4">
                <h5>Numero Total de visitas: {{numeroVisitas}}</h5>
            </div>
        </div>
        <br>
        
        <div class="row">
            
            <div class="col-md-4">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Pais</th>
                            <th>Ciudad</th>
                            <th>Cantidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let result of List_Reporte_Pais">
                            <th>{{result.country}}</th>
                            <th>{{result.city}}</th>
                            <th>{{result.cantidad}}</th>
        
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-6">
                <ngx-charts-pie-chart [view]="[800,600]" [results]="List_Reporte_x_pais_Grafico" [gradient]="gradient"
                    [legend]="showLegend" [labels]="showLabels" [doughnut]="isDoughnut" (select)="onSelect($event)"
                    (activate)="onActivate($event)" (deactivate)="onDeactivate($event)">
                </ngx-charts-pie-chart>
            </div>

    </div>
</div>
